import { Injectable, inject } from '@angular/core';

import { ProductService, StylesService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class StylesLazyLoadingService {
    private readonly stylesService = inject(StylesService);
    private readonly productService = inject(ProductService);

    async lazyLoad(aliasOrPath: string): Promise<void> {
        if (this.productService.isSingleDomainApp) {
            return;
        }

        await this.stylesService.load(aliasOrPath);
    }
}
